export interface ProfileFact {
  label: string;
  value: string;
}

export interface TimelineEntry {
  year: string;
  title: string;
  description: string;
}

export interface GalleryImage {
  src: string;
  caption: string;
}

export interface ExternalLink {
  name: string;
  description: string;
  url: string;
}

export const profileIntro = {
  name: "森泽佳奈",
  title: "演员 · 歌手 · 词曲创作者",
  tagline: "在光影与旋律之间，寻找属于作品的温度。",
  photo:
    "https://readdy.ai/api/search-image?query=cinematic%20editorial%20portrait%20of%20an%20elegant%20young%20asian%20woman%20looking%20calmly%20at%20the%20camera%20in%20soft%20studio%20light%2C%20wearing%20a%20refined%20neutral%20outfit%2C%20deep%20navy%20backdrop%20with%20warm%20amber%20accent%2C%20minimal%20high%20detail%20photography%2C%20graceful%20artistic%20mood&width=800&height=1000&seq=profile-main&orientation=portrait",
  bio: [
    "森泽佳奈，演员、歌手与词曲创作者，以细腻而克制的表演风格与真诚的音乐创作受到关注。她擅长在安静的叙事中传递强烈的情感，被视为新生代中兼具商业质感与艺术追求的代表人物之一。",
    "自出道以来，森泽佳奈横跨影视与音乐两个领域持续创作。她主演的多部影视作品以人物刻画见长，而个人音乐专辑则在流行旋律与艺术表达之间取得平衡，多次登上数字音乐榜单前列。",
    "她相信作品是创作者与观众之间最诚实的对话，因此始终坚持以真诚的态度对待每一个角色与每一首歌曲。除创作之外，她也长期关注海洋环保等公益议题。",
  ],
};

export const profileFacts: ProfileFact[] = [
  { label: "出生日期", value: "1998 年 3 月 21 日" },
  { label: "出生地", value: "日本 · 神奈川" },
  { label: "身高", value: "166 cm" },
  { label: "出道时间", value: "2021 年" },
  { label: "专业领域", value: "影视表演 / 流行音乐" },
  { label: "创作身份", value: "演员 / 歌手 / 词曲创作" },
];

export const profileTimeline: TimelineEntry[] = [
  {
    year: "2021",
    title: "正式出道",
    description: "以电视剧《雾都纪事》中的特别出演首次亮相，凭借神秘而克制的表演受到关注。",
  },
  {
    year: "2022",
    title: "影视与音乐双线起步",
    description: "主演青春电影《夏日信笺》，并发行首支个人单曲《初见》，正式进入音乐领域。",
  },
  {
    year: "2023",
    title: "首张专辑发行",
    description: "推出首张个人专辑《海边的房间》，以简约真诚的风格确立个人音乐辨识度。",
  },
  {
    year: "2024",
    title: "作品风格成熟",
    description: "主演电影《远山的回声》收获口碑，单曲《星空回响》进一步拓宽创作边界。",
  },
  {
    year: "2026",
    title: "多领域全面绽放",
    description: "主演电影《静默之城》定档，发行第三张专辑《潮汐》，并启动个人巡演计划。",
  },
];

export const profileAchievements: string[] = [
  "主演电影《静默之城》入围多个国际影展展映单元",
  "第三张个人专辑《潮汐》发行首周登顶数字音乐榜",
  "凭借电影《远山的回声》获得年度新人表演提名",
  "担任海洋环保公益项目「蓝海计划」形象大使",
  "个人巡演《光影之旅》覆盖五座城市，票房表现亮眼",
];

export const profileGallery: GalleryImage[] = [
  {
    src: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20film%20premiere%20moment%20with%20warm%20spotlights%20and%20deep%20navy%20backdrop%2C%20elegant%20atmosphere%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20graceful%20mood&width=800&height=600&seq=profile-gallery-01&orientation=landscape",
    caption: "《静默之城》首映礼现场",
  },
  {
    src: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20recording%20studio%20with%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20microphone%20in%20focus%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20intimate%20creative%20mood&width=800&height=600&seq=profile-gallery-02&orientation=landscape",
    caption: "专辑《潮汐》录音室日常",
  },
  {
    src: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20live%20concert%20stage%20with%20deep%20navy%20beam%20lights%20and%20warm%20amber%20glow%2C%20hazy%20atmosphere%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20energetic%20mood&width=800&height=600&seq=profile-gallery-03&orientation=landscape",
    caption: "巡演《光影之旅》舞台瞬间",
  },
  {
    src: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20calm%20sea%20shore%20at%20dawn%20with%20deep%20navy%20water%20and%20warm%20amber%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20serene%20contemplative%20mood&width=800&height=600&seq=profile-gallery-04&orientation=landscape",
    caption: "「蓝海计划」公益行动",
  },
];

export const profileLinks: ExternalLink[] = [
  {
    name: "官方微博",
    description: "森泽佳奈本人及团队的日常动态与活动信息",
    url: "https://ka-chao.cn/weibo",
  },
  {
    name: "音乐平台主页",
    description: "专辑、单曲与现场版本的完整试听入口",
    url: "https://ka-chao.cn/music",
  },
  {
    name: "媒体报道合集",
    description: "历年影视与音乐相关报道的整理归档（示例）",
    url: "https://ka-chao.cn/press",
  },
];